<div
  class="multi-select-field"
  [ngClass]="{
    'has-value': selectedOptionsLabel || placeholder,
    condensed: condensed
  }"
>
  <div
    class="select-label-wrapper field-label"
    [ngClass]="{
      'sr-text': hideLabel,
      disabled: formControl?.disabled
    }"
  >
    <label
      class="select-label"
      [attr.type]="'select'"
      [attr.for]="fieldId"
      (click)="dropdown.open()"
    >
      {{ label }}
    </label>

    <app-icon
      *ngIf="icon"
      class="icon"
      [icon]="icon"
      (click)="onClickIcon.emit()"
    >
    </app-icon>
  </div>

  <app-dropdown
    #dropdown
    class="select-dropdown"
    [dropdownGroupedItems]="dropdownValues"
    [disabled]="isDisabled"
    [dropdownId]="fieldId"
    [triggerBadge]="counter"
    [horizontalAlignment]="horizontalAlignment"
    [verticalAlignment]="verticalAlignment"
    [dynamicVAlignment]="dynamicVAlignment"
    [triggerLabel]="selectedOptionsLabel || placeholder"
    [trackingObject]="trackingObject"
    [trackingAction]="trackingTapped"
    [trackingAdditionalProperties]="trackingAdditionalProperties"
  >
    <ng-template
      let-closeCallback="closeCallback"
      let-selectOption="dropdownItem"
    >
      <button
        *ngIf="selectOption?.valueControl"
        type="button"
        class="multi-select-option"
        [disabled]="isDisabled"
        (click)="onSelect(selectOption)"
      >
        <div class="select-option-contents">
          <app-checkbox-field
            [label]="selectOption.key"
            [fieldControl]="selectOption.valueControl"
          >
          </app-checkbox-field>

          <app-icon
            *ngIf="selectOption.icon"
            class="select-option-icon"
            [icon]="selectOption.icon"
          >
          </app-icon>
        </div>
      </button>
    </ng-template>
  </app-dropdown>
</div>

<app-error-message [fieldControl]="fieldControl" [errorMessage]="errorMessage">
</app-error-message>
